import { render, staticRenderFns } from "./SingleProjectStatusPills.vue?vue&type=template&id=76313c8e&scoped=true&"
import script from "./SingleProjectStatusPills.vue?vue&type=script&lang=js&"
export * from "./SingleProjectStatusPills.vue?vue&type=script&lang=js&"
import style0 from "./SingleProjectStatusPills.vue?vue&type=style&index=0&id=76313c8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76313c8e",
  null
  
)

export default component.exports